import script from "./FeedbackForm.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackForm.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackForm.vue?vue&type=style&index=0&id=54a31ee9&lang=scss"

const __exports__ = script;

export default __exports__